import script from "./RadioFields.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioFields.vue?vue&type=script&setup=true&lang=js"

import "./RadioFields.vue?vue&type=style&index=0&id=4db52d2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db52d2a"]])

export default __exports__